
<div *ngFor="let box of totalAndActiveCounts">
  <div class="col-12 md:col-6 lg:col-3 active-box">
    <span>{{box.label}}</span>
    <span class="special-count">{{box.value }}</span>
  </div>
</div>